module.exports = __webpack_public_path__ + "img/融资icon.38e5868c.png";